import { loadLazy } from 'uix/utils';
// #if process.env.UIX_CHUNKED === 'true'
const Tree = loadLazy(()=>import(/* webpackChunkName: 'vtree' */ './vtree'));
// #endif
// #if process.env.UIX_CHUNKED !== 'true'
// import Tree from './vtree'
// #endif
export { Tree };
